module.exports = "/_next/static/images/icon-login-qq-87815cd9.png";